import type { Vertical } from "@/types/common";
import type { VerificationTier } from "@/components/FlexauraVerifiedBadge";

export interface MerchantListing {
  id: string;
  name: string;
  vertical: Vertical;
  providers: string[]; // which BNPL providers accept them
  verificationTier: VerificationTier;
  verifiedDate: string; // ISO date of last verification
  verifiedProvider: string; // which provider catalogue confirmed
  averageAOV?: number;
  currency: string;
  disclaimer: string;
  providerUrl: string;
}

/** Default verification metadata for existing listings */
export const DEFAULT_VERIFICATION = {
  tier: "verified" as VerificationTier,
  verifiedDate: new Date().toISOString(),
  verifiedProvider: "Flexaura",
};
